import {
  Component,
  Input,
  HostBinding,
  OnChanges,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';

@Component({
  // tslint:disable:component-selector
  selector: '[ls-cr-button]',
  template: `
    <span class="button-wrapper" [class.hide-label]="loading">
      <ng-content></ng-content>
    </span>
    <span
      class="spinner"
      *ngIf="loading"
      [class.cr-button__content--loading]="loading"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <path
          class="cr-icon__base cr-icon__base-2"
          d="M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm0-3A5 5 0 1 0 8 3a5 5 0 0 0 0 10z"
          opacity=".3"
        ></path>
        <path
          class="cr-icon__base cr-icon__base-1"
          d="M8 13a1.5 1.5 0 0 1 0 3A8 8 0 0 1 .323 5.742a1.5 1.5 0 1 1 2.879.846A5 5 0 0 0 8 13z"
        ></path>
      </svg>
    </span>
  `,
  styleUrls: ['./cirrus-button.component.scss', '../styles/cirrus-button.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CirrusButtonComponent implements OnChanges, OnInit {
  @Input()
  public size: 'small' | 'medium' | 'large' | 'xlarge' = 'medium';

  @Input()
  public variant: 'default' | 'neutral' | 'primary' | 'secondary' | 'danger' =
    'neutral';

  @Input()
  public buttonType: 'outline' | 'fill' | 'icon' | 'iconOnly' = 'outline';

  @Input()
  public block = false;

  @Input()
  public noSpacing = false;

  @Input()
  public loading = false;

  @HostBinding('attr.disabled') @Input() public disabled: boolean;

  @HostBinding('class')
  public get classNames(): string {
    return this.elementClasses.join(' ');
  }
  private elementClasses: Array<string> = [];

  public ngOnInit(): void {
    this.createClasses();
  }

  public ngOnChanges(): void {
    this.createClasses();
  }

  private createClasses(): void {
    this.elementClasses = [];
    this.elementClasses.push('cr-button');
    this.elementClasses.push(`cr-button--${this.variant}`);
    this.elementClasses.push(`cr-button--${this.size}`);
    this.elementClasses.push(`cr-button--${this.buttonType}`);
    if (this.block) {
      this.elementClasses.push('cr-button--block');
    }
    if (this.noSpacing) {
      this.elementClasses.push('cr-button--no-spacing');
    }
    if (this.loading) {
      this.elementClasses.push('cr-button--loading');
      this.disabled = true;
    }
  }
}
